import axios from 'axios';
import { urlsServices } from '@/config/urls';

let httpUrl = `${urlsServices.GETWAY}api/finalidade`;
export const createFinalidade = async (finalidade) => {
  return await axios.post(`${httpUrl}/create`, finalidade).then((response) => response);
};

export const getListaFinalidades = async (filtros) => {
  return await axios.post(`${httpUrl}/listByFiltros`, filtros).then((response) => response);
};

export const getFinalidadeById = async (id) => {
  return await axios.get(`${httpUrl}/${id}`).then((response) => response);
};

export const deleteFinalidadeById = async (id) => {
  return await axios.delete(`${httpUrl}/${id}`).then((response) => response);
};
